// Componente de entradas de mercancía
// Merchandise entries component

import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox } from '@fortawesome/pro-light-svg-icons';
import { SectionBox } from '@shared/components/ui/SectionBox';
import { useMerchandiseKpis } from '../../hooks/useMerchandiseKpis';
import { Product } from '@shared/components/ui/Product';

interface InventoryMetricsProps {
  filters?: {
    shop_id?: number;
    cutoff_time?: string;
    date?: string;
  };
}

export const InventoryMetrics = ({ filters = {} }: InventoryMetricsProps) => {
  const { t } = useTranslation('homeModule');
  const { merchandiseKpis, isLoading } = useMerchandiseKpis(filters);

  if (isLoading) {
    return null;
  }

  return (
    <SectionBox className="bg-card-bg" data-testid="inventory-metrics">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-md bg-card-border flex items-center justify-center">
          <FontAwesomeIcon icon={faBox} className="w-4 h-4 text-success" />
        </div>
        <h3 className="text-sm font-medium">{t('inventory.merchandise_entries.title')}</h3>

        <p className="text-sm font-bold text-title ml-auto">
          {merchandiseKpis.merchandise_sum} {t('inventory.merchandise_entries.units')}
        </p>
      </div>

      <div className="space-y-4">
        {merchandiseKpis.merchandise_list.length === 0 ? (
          /* Estado vacío */
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <div className="w-12 h-12 rounded-lg bg-card-border flex items-center justify-center mb-4">
              <FontAwesomeIcon icon={faBox} className="w-6 h-6 text-subtext" />
            </div>
            <p className="text-sm text-complementary-text">{t('inventory.merchandise_entries.empty_message')}</p>
          </div>
        ) : (
          /* Lista de mercancía */
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {merchandiseKpis.merchandise_list.map((merchandise: any, index: number) => (
              <div
                key={`${merchandise.code}-${index}`}
                className="flex items-center justify-between py-3 border-b border-card-border"
              >
                <div className="flex items-center gap-3">
                  <Product
                    key={`${merchandise.code}-${index}`}
                    id={index}
                    name={merchandise.name}
                    code={merchandise.code}
                    src={merchandise.image_url || '/imagen/example.webp'}
                  />
                </div>
                <span className="text-xs text-title bg-card-border rounded-full py-1 px-3">{merchandise.qty}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </SectionBox>
  );
};
